import { forwardRef, useEffect } from "react";
import "../../css/Modal.css";
import { X } from "react-feather";
import { createPortal } from "react-dom";
import { toast, ToastContainer } from "react-toastify";

const CustomizedModal = forwardRef(
  (
    {
      minWidth = "1000px",
      minHeight = "",
      closeButton = true,
      children,
      onCloseCleanUp = () => {},
      clickOutSide = true,
    },
    ref
  ) => {
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (clickOutSide) {
          console.log("clickOutSide", clickOutSide);
          if (ref?.current && event.target === ref.current) {
            onCloseCleanUp();
            ref.current.close();
          }
        }
      };

      const dialogElement = ref?.current;

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "open"
          ) {
            const isOpen = dialogElement.hasAttribute("open");
            if (!isOpen) {
              console.log("Clearing queue");
              toast.dismiss();
            }
          }
        });
      });

      observer.observe(dialogElement, { attributes: true });

      if (dialogElement) {
        dialogElement.addEventListener("click", handleClickOutside);
      }

      return () => {
        if (dialogElement) {
          dialogElement.removeEventListener("click", handleClickOutside);
        }
      };
    }, [ref]);

    return createPortal(
      <dialog
        className="modal"
        style={{
          minWidth: minWidth,
          minHeight: minHeight,
          position: "relative",
          padding: "0",
          margin: "0",
          borderRadius: "0",
          overflowY : "auto",
        }}
        ref={ref}
      >
        {closeButton && (
          <div
            className="modal-close-container"
            style={{
              position: "absolute",
              right: 20,
              top: 20,
              cursor: "pointer",
              zIndex: "1000",
            }}
          >
            <X
              size={30}
              className="custom-modal-close"
              onClick={() => {
                if (ref?.current) {
                  onCloseCleanUp();
                  toast.dismiss();
                  ref.current.close();
                }
              }}
            />
          </div>
        )}
        <ToastContainer
          enableMultiContainer={true}
          containerId="Modal"
          hideProgressBar
          zIndex={2000}
        />
        {children}
      </dialog>,
      document.getElementById("modal")
    );
  }
);

export default CustomizedModal;
